<div style="margin: 20px;">

  <div class="box-container">
    <div class="box-header">
      <span>{{ 'sender.sender_email' | translate }}</span>
    </div>
    <div class="box-item">
      <span>{{ senderInfo?.sender }}</span>
    </div>
    <ng-container *ngIf="isAllowedToTrust(false) && !isTrustBtnHidden()">
      <div class="box-item justify-content-center" *ngIf="!isDomainInPersonalTrustedList(false)">
        <span class="ms-1" [matTooltip]="trustDomainBtnTooltip">
            <button class="phish-primary-btn" (click)="addToTrustList(false)" [disabled]="addingEmailToTrust">
              {{ 'shared.trust_btn' | translate }} {{ 'sender.email_address' | translate }}
            </button>
        </span>
      </div>
      <div *ngIf="isDomainInPersonalTrustedList(false)">
        <span class="d-block text-green-2-color mb-2" >{{'trusted_domains.trusted' | translate }}</span>

        <span class="ms-1 d-flex justify-content-center" [matTooltip]="trustDomainBtnTooltip">
          <button class="phish-primary-btn" (click)="removeFromTrustList(false)" [disabled]="addingEmailToTrust">
            {{ 'shared.untrust_btn' | translate }} {{ 'sender.email_address' | translate }}
          </button>
        </span>

        <mat-progress-spinner class="ms-1" diameter="20" color="primary" mode="indeterminate" *ngIf="addingEmailToTrust">
        </mat-progress-spinner>
      </div>
    </ng-container>
  </div>

  <div class="box-container" id="exchangeHistory">
    <div class="box-header">
      <span class="ellipsis">{{ 'sender.message_exchange_history' | translate }}</span>
    </div>
    <div class="box-item">
      <div class="p-0 text-blue-color me-3 " style="flex: 1;">
        <div class="d-flex justify-content-center align-items-center">
          <i class="ms-Icon ms-Icon--MailForward me-2" style="font-size: large;" aria-hidden="true"></i>
          <span>{{ 'sender.received' | translate }}</span>
        </div>
        <span class="d-flex justify-content-center" [ngClass]="getExchangeHistoryColor(senderInfo?.fromCount)">
          {{ senderInfo?.fromCount }}{{senderInfo?.fromCount == 20 ? '+' : ''}}
        </span>
      </div>
      <div class="p-0 text-blue-color ms-3" style="flex: 1;text-align: center;">
        <div class="d-flex justify-content-center align-items-center">
          <i class="ms-Icon ms-Icon--MailForwardMirrored me-2" style="font-size: large;"
             aria-hidden="true"></i>
          <span>{{ 'sender.sent' | translate }}</span>
        </div>
        <span class="d-flex justify-content-center" [ngClass]="getExchangeHistoryColor(senderInfo?.toCount)">
          {{ senderInfo?.toCount }}{{senderInfo?.toCount == 20 ? '+' : ''}}
        </span>
      </div>
    </div>
  </div>

  <div class="box-container" id="details">
    <div class="box-header">
      <span>{{ 'sender.details' | translate }}</span>
    </div>
    <div class="box-item" style="margin-bottom: 0 !important;">
      <span class="text-blue-color">{{ 'sender.domain_origin' | translate }}:</span>
    </div>
    <div class="box-item" style="margin-bottom: 0 !important;">
      <span [ngClass]="{'text-orange-color': senderInfo?.smtpOrigin == Constants.NOT_PROVIDED}">{{ senderInfo?.smtpOrigin }}</span>
    </div>
    <div class="box-item" style="margin-bottom: 0 !important;">
      <span *ngIf="senderInfo?.smtpOrigin != Constants.NOT_PROVIDED"
        [ngClass]="{'text-green-2-color': senderInfo?.smtpOriginMatchSender, 'red': !senderInfo?.smtpOriginMatchSender}">
        {{checkIfMatchSender(senderInfo?.smtpOriginMatchSender)}}
      </span>
    </div>


    <div class="box-item" style="margin-top: 20px !important; margin-bottom: 0 !important;">
      <span class="text-blue-color">{{ 'sender.reply_to' | translate }}</span>
      <span></span>
    </div>

    <div class="box-item" style="margin-bottom: 0 !important;">
      <span>{{ senderInfo?.replyTo }}</span>
    </div>
    <div class="box-item" style="margin-bottom: 0 !important;">
      <span [ngClass]="{'text-green-2-color': senderInfo?.replyToMatchSender, 'red': !senderInfo?.replyToMatchSender}">
        {{checkIfMatchSender(senderInfo?.replyToMatchSender)}}
      </span>
    </div>
  </div>

  <div class="box-container" id="senderDomainInfo">
    <div class="box-header">
      <span>{{'sender.sender_domain' | translate}}</span>
    </div>
    <div class="box-item">
      <span class="text-blue-color me-2">{{ 'sender.domain' | translate }}: </span>
      <span> {{ senderInfo?.domain }}</span>
    </div>

    <div class="mb-2" [ngClass]="{'box-item': !senderInfo?.isDomainTrusted && !senderInfo?.isSenderEmailInPersonalTrusted}">
      <span class="text-blue-color me-1">{{ "sender.in_trusted_domain_list" | translate }}: </span>
      <div class="align-items-center" [ngClass]="getTrustedColor()">
        <span> {{ getIsInTrustedListText() }}</span>
        <span *ngIf="senderInfo?.isDomainTrusted" style="font-size: 11px" class="ms-1">
          ({{ senderInfo?.isDomainPersonalTrusted == true ? ('shared.personal' | translate) : ('shared.organization' | translate) }})
        </span>
      </div>
    </div>
      <div class="box-item justify-content-center" *ngIf="isAllowedToTrust(false) && !isTrustBtnHidden()">
        <span class="ms-1" [matTooltip]="trustDomainBtnTooltip" *ngIf="!isDomainInPersonalTrustedList(true)">
          <button class="phish-primary-btn" (click)="addToTrustList(true)" [disabled]="addingDomainToTrust">
            {{ 'shared.trust_btn' | translate }} {{ 'sender.domain' | translate }}
          </button>
        </span>

        <span class="ms-1" [matTooltip]="trustDomainBtnTooltip" *ngIf="isDomainInPersonalTrustedList(true)">
          <button class="phish-primary-btn" (click)="removeFromTrustList(true)" [disabled]="addingDomainToTrust">
            {{ 'shared.untrust_btn' | translate }} {{ 'sender.domain' | translate }}
          </button>
        </span>

      <mat-progress-spinner class="ms-1" diameter="20" color="primary" mode="indeterminate" *ngIf="addingDomainToTrust">
      </mat-progress-spinner>
    </div>

    <div class="box-item">
      <span class="text-blue-color me-1">Age: </span>
      <ng-container>
        <span [ngClass]="getDomainAgeColor(senderInfo?.isDomainNew)">
          {{ senderInfo?.domainAge }}
        </span>
        <span *ngIf="showCheckBtn()" class="ms-1" style="text-decoration: underline; color: #0078d7; cursor: pointer">
          <button mat-raised-button (click)="retrieveDomainAge()" [disabled]="isRetrievingAge">Check</button>
        </span>

        <mat-progress-spinner class="ms-1" diameter="20" color="primary" mode="indeterminate" *ngIf="isRetrievingAge">
        </mat-progress-spinner>
      </ng-container>
    </div>
    <div class="box-item">
      <span class="text-blue-color me-2">{{ 'sender.security_protocols' | translate }}: </span>
    </div>
      <div class="box-item justify-content-around">
          <ng-container *ngFor="let protocol of ['dmarc', 'spf', 'dkim']">
              <div>
                  <span class="text-blue-color d-flex">{{ ('sender.' + protocol) | translate }} </span>
                  <span class="text-blue-color d-flex"
                        [ngClass]="getProtocolClass(riskInfo?.[protocol])"
                        [ngStyle]="{'font-size': riskInfo?.[protocol] == undefined ? '0.85rem' : ''}">
        {{ checkSecurityProtocols(riskInfo?.[protocol], protocol === 'dkim') }}
      </span>
              </div>
          </ng-container>
      </div>

      <div class="box-item">
      <span class="text-blue-color me-2">{{ 'sender.top_level_domain' | translate }}: </span>
      <span> {{ senderInfo?.topLevelDomain }}</span>
    </div>
    <div class="box-item">
      <span class="text-blue-color col-7">{{ 'sender.top_level_domain_category' | translate }}: </span>
      <span [ngClass]="getTldCategoryColor()" class="col-4"> {{ senderInfo?.topLevelDomainCategory }}</span>
    </div>
  </div>
</div>
